import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllEstoqueSaidaUseCase } from "../../../presentation/useCases/read/get_all_sainda_use_case";
import { SaidaProdutosFilter } from "../../models/saida_produtos_filter";
import { SaidaProduto } from "../../models/saida_produtos_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class GetAllSaidaProdutosUseCase
  extends BasePaginatedUseCase<SaidaProduto>
  implements IGetAllEstoqueSaidaUseCase {
  constructor(private readonly repository: IEstoqueRepository) {
    super();
  }

  async getAllListagemSaida(
    filter: SaidaProdutosFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {

    const response = await this.repository
      .getAllListagemSaida(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
